import React from 'react'
import Modal from '../../components/Modal'
import styles from './Withdraw.module.sass'

const ConfirmWithdrawModal = ({
  visible,
  onClose,
  address,
  assetSymbol,
  receiveValue,
  amountValue,
  feeValue,
  isRiskAccepted,
  onRiskChange,
  onConfirm,
}) => (
  <Modal
    visible={visible}
    onClose={onClose}
    isClosable
    outerClassName={styles.confirmModalOuter}
  >
    <div className={styles.confirmModal}>
      <div className={styles.confirmSection}>
        <div className={styles.confirmHeader}>
          <span>Withdraw to</span>
          <strong>Blockchain Address</strong>
        </div>
        <div className={styles.confirmRow}>
          <span>Address</span>
          <strong>{address || '--'}</strong>
        </div>
        <div className={styles.confirmRow}>
          <span>You Receive</span>
          <strong>{receiveValue.toFixed(6)} {assetSymbol}</strong>
        </div>
        <div className={styles.confirmRow}>
          <span>Withdrawal Amount</span>
          <strong>{amountValue.toFixed(6)} {assetSymbol}</strong>
        </div>
        <div className={styles.confirmRow}>
          <span>Withdrawal Fee</span>
          <strong>{feeValue} {assetSymbol}</strong>
        </div>
      </div>

      <div className={styles.riskBox}>
        <h3 className={styles.riskTitle}>Risk Warning</h3>
        <p className={styles.riskItem}>
          Please ensure the withdrawal address is correct. Once a withdrawal is completed, assets cannot be recovered.
        </p>
        <p className={styles.riskItem}>
          Platform staff will never guide, coerce, or intimidate you into making a withdrawal, nor will they claim your deposit or withdrawal is involved in criminal activity or money laundering.
        </p>
        <p className={styles.riskItem}>
          Be alert to any pyramid schemes, altcoin scams, unlawful fundraising, or other fraudulent activity.
        </p>
      </div>

      <label className={styles.confirmCheck}>
        <input
          type="checkbox"
          checked={isRiskAccepted}
          onChange={(e) => onRiskChange(e.target.checked)}
        />
        <span>I have checked the above withdrawal details and fully understand the risks.</span>
      </label>

      <div className={styles.confirmActions}>
        <button
          type="button"
          className={styles.cancelButton}
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className={`${styles.confirmButton} ${isRiskAccepted ? styles.confirmButtonActive : ''}`}
          disabled={!isRiskAccepted}
          onClick={onConfirm}
        >
          Confirm
        </button>
      </div>
    </div>
  </Modal>
)

export default ConfirmWithdrawModal
